import { createRouter, createWebHistory } from 'vue-router';
import DashboardAgent from '../views/DashboardAgent.vue';
import DashboardTraffic from '../views/DashboardTraffic.vue';
import TrainingAgent from '../views/TrainingAgent.vue';
import TrainingAgentCourse from '../views/TrainingAgentCourse.vue';
import TrainingAgentLecture from '../views/TrainingAgentLecture.vue';
import Interview from '../components/interview/Interview.vue';
import ApplyDetail from '../components/apply/ApplyDetail.vue';
import ApplyReferral from '../components/apply/ApplyReferral.vue';
import Jobs from '../components/job/Jobs.vue';
import JobNew from '../components/job/JobNew.vue';
import JobDetail from '../components/job/JobDetail.vue';
import JobEdit from '../components/job/JobEdit.vue';
import Contacts from '../components/contact/Contacts.vue';
import ContactCalendar from '../components/contact/ContactCalendar.vue';
import ContactDetail from '../components/contact/ContactDetail.vue';
import ContactEventDetail from '../components/contact_events/Detail.vue';
import PipelineReviewDetail from '../components/pipeline_reviews/Detail.vue';
import ContactNew from '../components/contact/ContactNew.vue';
import ContactEdit from '../components/contact/ContactEdit.vue';
import Team from '../components/team/Team.vue';
import TeamCalendar from '../components/team/TeamCalendar.vue';
import TeammateDetail from '../components/team/TeammateDetail.vue';
import TeammateNew from '../components/team/TeammateNew.vue';
import TeammatePipelineReviewsNew from '../components/team/TeammatePipelineReviewsNew.vue';
import TeammatePipelineReviewDetail from '../components/team/TeammatePipelineReviewDetail.vue';
import TeammateEdit from '../components/team/TeammateEdit.vue';
import Inbox from '../views/Inbox.vue';
import Tasks from '../views/Tasks.vue';
import ProfileSetting from '../components/setting/account/ProfileSetting.vue';
import Settings from '../components/setting/index.vue';
import NotificationSetting from '../components/setting/account/NotificationSetting.vue';
import EmailSetting from '../components/setting/account/EmailSetting.vue';
import CalendarSetting from '../components/setting/account/CalendarSetting.vue';
import BillingSetting from '../components/setting/company/BillingSetting.vue';
import CandidateSchedulingSetting from '../components/setting/company/CandidateSchedulingSetting.vue';
import CompanyProfileSetting from '../components/setting/company/CompanyProfileSetting.vue';
import LandingPageSettings from '../components/setting/company/LandingPageSettings.vue';
import LandingPageNew from '../components/setting/company/LandingPageNew.vue';
import AdvertisingSetting from '../components/setting/company/AdvertisingSetting.vue';
import TrainingChecklistSettings from '../components/setting/company/TrainingChecklistSettings.vue';
import OnboardingChecklistSettings from '../components/setting/company/OnboardingChecklistSettings.vue';
import OffboardingChecklistSettings from '../components/setting/company/OffboardingChecklistSettings.vue';
import OnboardingTaskChecklistDetail from '../components/task_checklists/OnboardingTaskChecklistDetail.vue';
import ChecklistTaskDetail from '../components/checklist_tasks/ChecklistTaskDetail.vue';
import UserTaskDetail from '../components/user_tasks/UserTaskDetail.vue';
import CustomFieldsList from '../components/setting/data/CustomFieldsList.vue';
import CustomFieldDetail from '../components/setting/data/CustomFieldDetail.vue';
import UsersSetting from '../components/setting/company/UsersSetting.vue';
import PandadocIntegration from '../components/setting/integrations/PandadocIntegration.vue';
import StripeIntegration from '../components/setting/integrations/StripeIntegration.vue';
import SyndicationIntegration from '../components/setting/integrations/SyndicationIntegration.vue';
import TelcoIntegration from '../components/setting/integrations/TelcoIntegration.vue';
import WebsiteIntegration from '../components/setting/integrations/WebsiteIntegration.vue';
import CandidateWorkflow from '../components/setting/workflows/CandidateWorkflow.vue';
import TeamWorkflow from '../components/setting/workflows/TeamWorkflow.vue';
import EmailTemplates from '../components/setting/templates/EmailTemplates.vue';
import SmsTemplates from '../components/setting/templates/SmsTemplates.vue';
import EsignatureTemplates from '../components/setting/templates/EsignatureTemplates.vue';
import EsignatureTemplateCreate from '../components/setting/templates/EsignatureTemplateCreate.vue';
import EsignatureTemplateEdit from '../components/setting/templates/EsignatureTemplateEdit.vue';
import Logout from '../views/Logout.vue';
import Onboarding from '../views/Onboarding.vue';
import HummerOnboarding from '../views/hummer/Onboarding/index.vue';
import Admin from '../views/Admin.vue';
import AdminTeamList from '../components/admin/TeamList.vue';
import AdminTeamDetail from '../components/admin/TeamDetail.vue';
import AdminBudgetRequests from '../components/admin/BudgetRequestsList.vue';
import AdminBudgetRequestDetail from '../components/admin/BudgetRequestDetail.vue';
import QuickstartPhoneNumber from '../views/quickstart/PhoneNumber.vue';
import QuickstartScheduleKickoffCall from '../views/quickstart/ScheduleKickoffCall.vue';

const routes = [
  {
    path: '/',
    name: 'Dashboard',
    component: DashboardTraffic,
  },
  {
    path: '/agents/onboarding',
    name: 'Onboarding',
    component: DashboardAgent,
  },
  {
    path: '/agents/onboarding/tasks/:id',
    name: 'Onboarding Task',
    component: UserTaskDetail,
  },
  {
    path: '/agents/university',
    name: 'Humaniz University',
    component: TrainingAgent,
  },
  {
    path: '/agents/university/courses/:id',
    name: 'New Agent Training Course',
    component: TrainingAgentCourse,
  },
  {
    path: '/agents/university/courses/:course_id/lectures/:id',
    name: 'New Agent Training Lecture',
    component: TrainingAgentLecture,
  },
  {
    path: '/interview/:id',
    name: 'Interview',
    component: Interview,
  },
  {
    path: '/apply/:id',
    name: 'ApplyDetail',
    component: ApplyDetail,
  },
  {
    path: '/apply_referral/:id',
    name: 'ApplyReferral',
    component: ApplyReferral,
  },
  {
    path: '/inbox',
    name: 'Inbox',
    component: Inbox,
  },
  {
    path: '/tasks',
    name: 'Tasks',
    component: Tasks,
  },
  {
    path: '/tasks/:id',
    name: 'Task Detail',
    component: UserTaskDetail,
  },
  {
    path: '/contacts',
    name: 'Candidates',
    component: Contacts,
  },
  {
    path: '/contacts/calendar',
    name: 'CandidatesCalendar',
    component: ContactCalendar,
  },
  {
    path: '/contacts/new',
    name: 'CandidateNew',
    component: ContactNew,
  },
  {
    path: '/contacts/:id/edit',
    name: 'CandidateEdit',
    component: ContactEdit,
  },
  {
    path: '/contacts/:id',
    name: 'CandidateDetail',
    component: ContactDetail,
  },
  {
    path: '/contact_events/:id/pipeline_review',
    name: 'Pipeline Review',
    component: PipelineReviewDetail,
  },
  {
    path: '/contact_events/:id/scorecard',
    name: 'Scorecard',
    component: ContactEventDetail,
  },
  {
    path: '/team',
    name: 'Team',
    component: Team,
  },
  {
    path: '/team/calendar',
    name: 'TeamCalendar',
    component: TeamCalendar,
  },
  {
    path: '/team/new',
    name: 'TeammateNew',
    component: TeammateNew,
  },
  {
    path: '/team/:id/edit',
    name: 'TeammateEdit',
    component: TeammateEdit,
  },
  {
    path: '/team/:id',
    name: 'TeammateDetail',
    component: TeammateDetail,
  },
  {
    path: '/team/:contactId/pipeline_reviews/new',
    name: 'Pipeline Reviews New',
    component: TeammatePipelineReviewsNew,
  },
  {
    path: '/team/:contactId/pipeline_reviews/:id',
    name: 'Pipeline Reviews Detail',
    component: TeammatePipelineReviewDetail,
  },
  {
    path: '/settings',
    name: 'Settings',
    component: Settings,
  },
  {
    path: '/settings/company/profile',
    name: 'CompanyProfileSetting',
    component: CompanyProfileSetting,
  },
  {
    path: '/settings/company/users',
    name: 'UsersSetting',
    component: UsersSetting,
  },
  {
    path: '/settings/company/billing',
    name: 'BillingSetting',
    component: BillingSetting,
  },
  {
    path: '/settings/company/scheduling',
    name: 'CandidateSchedulingSetting',
    component: CandidateSchedulingSetting,
  },
  {
    path: '/settings/company/landing_pages',
    name: 'LandingPages',
    component: LandingPageSettings,
  },
  {
    path: '/settings/company/landing_pages/new',
    name: 'LandingPagesNew',
    component: LandingPageNew,
  },
  {
    path: '/settings/company/advertising',
    name: 'AdvertisingSetting',
    component: AdvertisingSetting,
  },
  {
    path: '/settings/company/onboarding_checklists',
    name: 'Onboarding Checklist',
    component: OnboardingChecklistSettings,
  },
  {
    path: '/settings/company/onboarding_checklists/:id/edit',
    name: 'Onboarding Checklist Edit',
    component: OnboardingTaskChecklistDetail,
  },
  {
    path: '/settings/company/onboarding_checklists/:checklistId/tasks/:id/edit',
    name: 'Onboarding Task Edit',
    component: ChecklistTaskDetail,
  },
  {
    path: '/settings/company/training_checklists',
    name: 'Training Checklist',
    component: TrainingChecklistSettings,
  },
  {
    path: '/settings/company/training_checklists/:id/edit',
    name: 'Training Checklist Edit',
    component: OnboardingTaskChecklistDetail,
  },
  {
    path: '/settings/company/training_checklists/:checklistId/tasks/:id/edit',
    name: 'Training Task Edit',
    component: ChecklistTaskDetail,
  },
  {
    path: '/settings/company/offboarding_checklists',
    name: 'Offboarding Checklist',
    component: OffboardingChecklistSettings,
  },
  {
    path: '/settings/company/offboarding_checklists/:id/edit',
    name: 'Offboarding Checklist Edit',
    component: OnboardingTaskChecklistDetail,
  },
  {
    path: '/settings/company/offboarding_checklists/:checklistId/tasks/:id/edit',
    name: 'Offboarding Task Edit',
    component: ChecklistTaskDetail,
  },
  {
    path: '/settings/data/custom_fields',
    name: 'Custom Fields',
    component: CustomFieldsList,
  },
  {
    path: '/settings/data/custom_fields/:id/edit',
    name: 'Custom Field Detail',
    component: CustomFieldDetail,
  },
  {
    path: '/settings/account/profile',
    name: 'ProfileSetting',
    component: ProfileSetting,
  },
  {
    path: '/settings/account/email',
    name: 'EmailSetting',
    component: EmailSetting,
  },
  {
    path: '/settings/account/calendar',
    name: 'CalendarSetting',
    component: CalendarSetting,
  },
  {
    path: '/settings/account/notifications',
    name: 'NotificationSetting',
    component: NotificationSetting,
  },
  {
    path: '/settings/integrations/pandadoc',
    name: 'PandadocIntegration',
    component: PandadocIntegration,
  },
  {
    path: '/settings/integrations/stripe',
    name: 'StripeIntegration',
    component: StripeIntegration,
  },
  {
    path: '/settings/integrations/telco',
    name: 'TelcoIntegration',
    component: TelcoIntegration,
  },
  {
    path: '/settings/integrations/website',
    name: 'WebsiteIntegration',
    component: WebsiteIntegration,
  },
  {
    path: '/settings/integrations/syndication',
    name: 'SyndicationIntegration',
    component: SyndicationIntegration,
  },
  {
    path: '/settings/workflows/candidate',
    name: 'CandidateWorkflow',
    component: CandidateWorkflow,
  },
  {
    path: '/settings/workflows/team',
    name: 'TeamWorkflow',
    component: TeamWorkflow,
  },
  {
    path: '/settings/templates/email',
    name: 'EmailTemplates',
    component: EmailTemplates,
  },
  {
    path: '/settings/templates/sms',
    name: 'SmsTemplates',
    component: SmsTemplates,
  },
  {
    path: '/settings/templates/esignature',
    name: 'EsignatureTemplates',
    component: EsignatureTemplates,
  },
  {
    path: '/settings/templates/esignature/new',
    name: 'EsignatureTemplateCreate',
    component: EsignatureTemplateCreate,
  },
  {
    path: '/settings/templates/esignature/:id/edit',
    name: 'EsignatureTemplateEdit',
    component: EsignatureTemplateEdit,
  },
  {
    path: '/logout',
    name: 'Logout',
    component: Logout,
  },
  {
    path: '/jobs',
    name: 'Jobs',
    component: Jobs,
  },
  {
    path: '/jobs/new',
    name: 'JobNew',
    component: JobNew,
  },
  {
    path: '/jobs/:id',
    name: 'JobDetail',
    component: JobDetail,
  },
  {
    path: '/jobs/:id/edit',
    name: 'JobEdit',
    component: JobEdit,
  },
  {
    path: '/welcome',
    name: 'NewAccountOnboarding',
    component: Onboarding,
  },
  {
    path: '/start',
    name: 'HummerOnboarding',
    component: HummerOnboarding,
  },
  {
    path: '/admin',
    name: 'Admin',
    component: Admin,
  },
  {
    path: '/admin/teams',
    name: 'Teams Admin',
    component: AdminTeamList,
  },
  {
    path: '/admin/teams/:id',
    name: 'Team Admin',
    component: AdminTeamDetail,
  },
  {
    path: '/admin/budget_requests',
    name: 'Budget Requests Admin',
    component: AdminBudgetRequests,
  },
  {
    path: '/admin/budget_requests/:id',
    name: 'Budget Request Admin',
    component: AdminBudgetRequestDetail,
  },
  {
    path: '/quickstart/phone_number',
    name: 'QuickstartPhoneNumber',
    component: QuickstartPhoneNumber,
  },
  {
    path: '/quickstart/schedule_kickoff_call',
    name: 'QuickstartScheduleKickoffCall',
    component: QuickstartScheduleKickoffCall,
  },
];

const router = createRouter({
  history: createWebHistory('/'),
  routes,
});

export default router;
